import { Lock } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { getModuleDefinitions, getModuleLabel } from "../../lib/deliverableConfig";
import { cn } from "@/lib/utils";

export default function DeliverableModulesPanel({ deliverableType, moduleState, onToggle, className }) {
  const defs = getModuleDefinitions(deliverableType);

  return (
    <div className={cn("rounded-2xl border border-slate-200 bg-white shadow-sm p-4 sm:p-5", className)}>
      <h2 className="text-xs font-semibold text-slate-600 uppercase tracking-wide">Módulos del documento</h2>
      <p className="text-[11px] text-slate-500 mt-1 mb-3">Active o desactive secciones opcionales.</p>
      <ul className="space-y-2">
        {defs.map((def) => {
          const checked = !!moduleState[def.id];
          const disabled = def.fixed;
          return (
            <li key={def.id} className="flex items-start gap-3">
              <Checkbox
                id={`mod-${def.id}`}
                checked={checked}
                disabled={disabled}
                onCheckedChange={(v) => !disabled && onToggle(def.id, v === true)}
                className="mt-0.5 border-slate-300 data-[state=checked]:bg-sky-600 data-[state=checked]:border-sky-600"
              />
              <label htmlFor={`mod-${def.id}`} className={cn("flex-1 text-xs leading-snug", disabled && "cursor-default")}>
                <span className="text-slate-700 font-medium">{getModuleLabel(def.id)}</span>
                {disabled && (
                  <span className="ml-2 inline-flex items-center gap-1 text-xs font-medium text-sky-700 bg-sky-50 border border-sky-100 rounded-md px-1.5 py-0.5">
                    <Lock className="h-3 w-3 shrink-0" aria-hidden />
                    Obligatorio
                  </span>
                )}
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
